export default __webpack_public_path__ + "static/media/addAnnouncementWhite.626f2e7c.svg";